
// -1 灰色，0 暗，1 亮
const gameConfig = [
  // 0关
  [
    [-1, -1, -1, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
  ],
  // 1关
  [
    [-1, -1, -1, -1, -1, -1],
    [-1, 0, 1, 0, 0, -1],
    [-1, -1, -1, -1, -1, -1],
  ],
  // 2关
  [
    [-1, -1, 1, -1, -1, -1],
    [0, -1, -1, -1, 0, -1],
    [0, 0, 0, 0, 0, -1],
  ],
  // 3关
  [
    [-1, -1, 0, 0, -1, -1],
    [-1, 0, 0, 0, 0, -1],
    [-1, 0, 0, 0, 0, -1],
  ],
  // 4关
  [
    [-1, 0, 0, 0, 0, -1],
    [1, -1, -1, -1, 0, -1],
    [-1, 0, 0, 0, 0, -1],
  ],
  // 5关
  [
    [0, 0, 0, 0, 0, 0],
    [0, -1, -1, -1, -1, 0],
    [0, -1, -1, -1, -1, 1],
  ],
  // 6关
  [
    [0, 0, -1, -1, 0, 0],
    [0, -1, -1, -1, -1, 0],
    [0, 0, 0, -1, -1, 0],
  ],
  // 7关
  [
    [-1, -1, 0, 0, -1, -1],
    [-1, 0, 0, 1, 0, -1],
    [0, 0, 0, 0, 0, 0],
  ],
  // 8关
  [
    [-1, 0, 0, 0, 0, -1],
    [-1, 0, 0, 0, 0, -1],
    [-1, 0, 0, 0, 0, -1],
  ],
  // 9关
  [
    [-1, -1, 0, 0, -1, -1],
    [-1, -1, 0, 0, -1, -1],
    [-1, -1, -1, -1, -1, -1],
  ],
  // 10关
  [
    [-1, -1, 0, 0, 0, -1],
    [-1, -1, 0, -1, 0, -1],
    [-1, -1, 0, 0, 0, -1],
  ],
  // 11关
  [
    [-1, -1, -1, 0, -1, -1],
    [-1, -1, 0, 0, 0, -1],
    [-1, 0, 0, 0, 0, 0],
  ],
  // 12关
  [
    [0, -1, 0, 0, -1, 0],
    [-1, 0, -1, -1, 0, -1],
    [0, 0, 0, 0, 0, 0],
  ],
  // 13关
  [
    [-1, -1, 0, 0, -1, -1],
    [-1, -1, 0, 0, -1, -1],
    [-1, -1, 0, 0, -1, -1],
  ],
  // 14关
  [
    [0, 0, -1, 0, 0, 0],
    [0, 0, -1, 0, 0, 0],
    [0, 0, -1, 0, 0, 0],
  ],
  // 15关
  [
    [0, 0, -1, -1, -1, 1],
    [0, -1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0],
  ],
  // 16关
  [
    [1, 0, 0, 0, 0, 0],
    [-1, -1, -1, 0, -1, -1],
    [1, 0, 0, 0, 0, 0],
  ],
  // 17关
  [
    [-1, 0, 0, 0, 0, -1],
    [-1, 0, -1, -1, 0, -1],
    [-1, 0, 0, 0, 0, -1],
  ],
  // 18关
  [
    [0, -1, 0, 0, -1, -1],
    [1, 1, 0, 0, -1, -1],
    [0, -1, 0, 0, -1, -1],
  ],
  // 19关
  [
    [-1, 0, -1, 0, -1, 0],
    [0, 1, 0, 1, 0, -1],
    [-1, 0, -1, 0, -1, 0],
  ],
  // 20关
  [
    [0, 0, -1, -1, -1, -1],
    [0, -1, -1, 0, 1, -1],
    [0, 0, -1, 0, 0, -1],
  ],
  // 21关
  [
    [-1, -1, -1, 0, 0, 0],
    [-1, 1, -1, 0, 0, 0],
    [-1, -1, -1, 0, 0, 0],
  ],
  // 22关
  [
    [0, -1, -1, 0, 0, 0],
    [0, -1, -1, -1, -1, 0],
    [0, 0, -1, -1, -1, -1],
  ],
  // 23关
  [
    [0, 0, 0, -1, -1, -1],
    [0, -1, 0, -1, 0, 1],
    [0, 0, 0, -1, -1, 0],
  ],
];

const strategyConfig = [
  [
    [-1, -1, -1, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
  ],
  // 1关
  [
    [-1, -1, -1, -1, -1, -1],
    [-1, 2, -1, 1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
  ],
  [
    [-1, -1, -1, -1, -1, -1],
    [1, -1, -1, -1, 3, -1],
    [-1, -1, 2, -1, -1, -1],
  ],
  // 3关
  [
    [-1, -1, -1, -1, -1, -1],
    [-1, -1, 1, 4, -1, -1],
    [-1, -1, 2, 3, -1, -1],
  ],
  [
    [-1, -1, 1, -1, -1, -1],
    [-1, -1, -1, -1, 3, -1],
    [-1, -1, 2, -1, -1, -1],
  ],
  // 5关
  [
    [-1, -1, 2, -1, -1, 3],
    [1, -1, -1, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
  ],
  [
    [1, -1, -1, -1, 4, -1],
    [-1, -1, -1, -1, -1, -1],
    [-1, 2, -1, -1, -1, 3],
  ],
  // 7关
  [
    [-1, -1, 2, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
    [-1, 1, -1, -1, 3, -1],
  ],
  [
    [-1, 10, 9, 8, 7, -1],
    [-1, 1, -1, -1, 6, -1],
    [-1, 2, 3, 4, 5, -1],
  ],
  // 9关
  [
    [-1, -1, 1, 2, -1, -1],
    [-1, -1, 4, 3, -1, -1],
    [-1, -1, -1, -1, -1, -1],
  ],
  [
    [-1, -1, 1, 2, 3, -1],
    [-1, -1, 8, -1, 4, -1],
    [-1, -1, 7, 6, 5, -1],
  ],
  // 11关
  [
    [-1, -1, -1, -1, -1, -1],
    [-1, -1, -1, 1, -1, -1],
    [-1, 2, -1, -1, -1, 3],
  ],
  [
    [1, -1, 4, -1, -1, 5],
    [-1, -1, -1, -1, -1, -1],
    [-1, 2, -1, -1, 3, -1],
  ],
  // 13关
  [
    [-1, -1, 1, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
    [-1, -1, -1, 2, -1, -1],
  ],
  [
    [1, -1, -1, 3, -1, 6],
    [-1, -1, -1, -1, 7, -1],
    [-1, 2, -1, 4, -1, 5],
  ],
  // 15关
  [
    [1, -1, -1, -1, -1, -1],
    [-1, -1, -1, 3, -1, -1],
    [-1, 2, -1, -1, -1, 4],
  ],
  [
    [-1, -1, 1, -1, 4, -1],
    [-1, -1, -1, 3, -1, -1],
    [-1, -1, 2, -1, 5, -1],
  ],
  // 17关
  [
    [-1, 1, 10, 9, 8, -1],
    [-1, 2, -1, -1, 7, -1],
    [-1, 3, 4, 5, 6, -1],
  ],
  [
    [1, -1, 3, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
    [2, -1, -1, 4, -1, -1],
  ],
  // 19关
  [
    [-1, 4, -1, 5, -1, 9],
    [1, -1, 3, -1, 7, -1],
    [-1, 2, -1, 6, -1, 8],
  ],
  [
    [1, -1, -1, -1, -1, -1],
    [-1, -1, -1, -1, -1, -1],
    [-1, 2, -1, 3, -1, -1],
  ],
  // 21关
  [
    [-1, -1, -1, 1, -1, 4],
    [-1, -1, -1, -1, 5, -1],
    [-1, -1, -1, 2, -1, 3],
  ],
  [
    [1, -1, -1, 3, -1, -1],
    [-1, -1, -1, -1, -1, 4],
    [-1, 2, -1, -1, -1, -1],
  ],
  // 23关
  [
    [1, 8, 7, -1, -1, -1],
    [2, -1, 6, -1, 9, -1],
    [3, 4, 5, -1, -1, 10],
  ],
]

export {
  gameConfig,
  strategyConfig,
};
